import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Paper, Typography } from '@mui/material';
import PersonForm from './PersonForm';
import SkeletonBlock from '../ui/SkeletonBlock';
import EmptyState from '../ui/EmptyState';
import { peopleService } from '../../services/api';

export default function PersonEditPage(){
  const { id } = useParams();
  const personId = id ? parseInt(id) : null;
  const [person, setPerson] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    if (!personId) {
      setLoading(false);
      setError(true);
      return;
    }
    let mounted = true;
    (async () => {
      try {
        const p = await peopleService.getById(personId);
        if (mounted) {
          setPerson(p);
          setLoading(false);
        }
      } catch (err) {
        if (mounted) {
          setError(true);
          setLoading(false);
        }
      }
    })();
    return () => { mounted = false; };
  }, [personId]);

  const personIdValue = person?.Id ?? person?.id;

  return (
    <Box sx={{ p:2 }}>
      <Paper sx={{ p:2 }}>
        <Typography variant="h6" sx={{ mb:1 }}>Edit Person</Typography>
        {loading && <SkeletonBlock rows={8} />}
        {!loading && error && <EmptyState title="Person not found" description="The requested person could not be loaded." />}
        {!loading && !error && person && (
          <PersonForm person={person} disabled={!personIdValue} onSaved={() => { /* no global refresh */ }} />
        )}
      </Paper>
    </Box>
  );
}

